import { useEffect, useState } from "react";
import { LocationOrigin } from "../../utils/utilityServices";
import { Authentication } from "../../utils/authenticationUtilityServices";
import Services from "../../utils/services";
import axios from "axios";
import PubMedAuthorDocumentCard from './PubMedAuthorDocumentCard';
import PageItems from "../../components/Paginate/PageItems";
import Pagination from "../Paginate/Pagination";


let _locationOrigin = LocationOrigin;
//_locationOrigin = "https://predev-ims.jnj.com";
let _timeoutTime = (1000 * (300));

const PubMedCitationCard = (props) => {
    const [customWidth, setCustomWidth] = useState(window.innerWidth);
    const [customHeight, setCustomHeight] = useState(window.innerHeight);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isProcessing, setIsProcessing] = useState(true);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [documentCount, setDocumentCount] = useState(0);
    const [response, setResponse] = useState([]);

    const [spinnerMessage, setSpinnerMessage] = useState("");
    const [error, setError] = useState("");
    const [errorExpand, setErrorExpand] = useState(true);
    const [citation, setCitation] = useState([])


    useEffect(() => {
        let citationVal = JSON.parse(sessionStorage.getItem('citationVal'))
        setCitation(citationVal)
        fetchCitation(citationVal, itemsPerPage, currentPage)//citation, _ItemsPerPage, _currentPage
    }, [])
    const fetchCitation = async (citation, _ItemsPerPage, _currentPage) => {

        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search/pmids`;
        if (window.location.origin === "https://predev-ims.jnj.com") {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}search/pmids`;
        } const _headers = {
            "Content-Type": "application/json",
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        let config = {
            method: "POST",
            url: url,
            headers: _headers,
            timeout: _timeoutTime,
        };
        config.data = {
            pmids: citation,
            from_: _currentPage * _ItemsPerPage - _ItemsPerPage,
            size: parseInt(_ItemsPerPage),
        };
        axios(config)
            .then((response) => {
                setDocumentCount(response.data.hits.total.value);//data.hits.total.value
                setResponse(response.data.hits.hits);
                setIsLoaded(true);
                setIsProcessing(false);
            })
            .catch((err) => {
                setError(err);
                console.log({ err })

            })
            .finally(() => {
                setIsLoaded(true);
                setIsProcessing(false);
            });

    }
    const createErrorHtml = () => {
        if (error.response) {
            let _JSON = error.response.data;
            let mailbody = "";
            if (_JSON) {
                mailbody = encodeURIComponent(JSON.stringify(_JSON));
            }
            return (
                <>
                    <p style={{ wordBreak: "break-all" }}>
                        <b>ERROR: </b>
                        {_JSON.ERROR}
                        <br />
                        <b>MESSAGE: </b>
                        {_JSON && _JSON.message ? <>
                            {_JSON.message}
                        </> :
                            <>
                                {(_JSON.detail && _JSON.detail.length > 0 && _JSON.detail[0].msg) ? <>{_JSON.detail[0].msg}</> : <>{_JSON.MESSAGE}</>}
                            </>}

                        <br />
                        {(_JSON && _JSON.stackTrace) && <>
                            <b>STACKTRACE: </b>
                            {_JSON.stackTrace}
                            <br />
                        </>}
                        {(_JSON.detail && _JSON.detail.length > 0 && _JSON.detail[0].type) && <>
                            <b>TYPE: </b>
                            {_JSON.detail[0].type}
                            <br />
                        </>}
                        <br />
                        <b> Please contact{" "}
                            <a
                                href={`mailto:imks.jnj.com?subject= iMS PubMed2.0 Query Error - ${_JSON["REQUEST-ID"]}&body=${mailbody}`}
                            >
                                iMedical Search Support Team
                            </a></b>

                    </p>
                </>
            );
        } else {
            return error.message;
        }
    };
    const resultList = (results, itemsPerPage, currentPage) => {
        try {
            var startIndex;
            startIndex = currentPage * itemsPerPage - itemsPerPage;
            var count = startIndex;
            let displayedResults = [];

            return (<>
                {(() => {
                    if (results.length > 0) {
                        return (
                            <>
                                <div className="pubmed-main-right-section-result-list box-white-main">
                                    <div
                                        className="sticky top-16 z-2 overflow-hidden rounded-border-20 bg-white/95 backdrop-blur dark:bg-secondary-950/75"
                                        // ref={(el) => {
                                        //     this.scrollingTableHeader = el;
                                        // }}
                                        id="scrolling-table-header"
                                    ></div>
                                    <div
                                        className="overflow-x-auto pubmed-main-right-section-result-list-body pt-1"
                                    // onScroll={(e) => this.handleScroll(e)}
                                    >
                                        <div>
                                            {results.map((item, index) => {
                                                count++;
                                                return (
                                                    <>
                                                        <div
                                                            key={`result-id-${index}`}
                                                            id={`result-id-${index}`}
                                                            className="mx-1 mb-2 rounded-2xl border-2 border-secondary-100 pubmed-main-result-item-border"
                                                        >
                                                            <PubMedAuthorDocumentCard
                                                                item={item._source}
                                                                pageNumber={currentPage}
                                                                pageSize={itemsPerPage}
                                                                count={count}
                                                                appliedFilters={[]}
                                                                searchKeyword={""}
                                                                isChecked={
                                                                    false
                                                                }
                                                                customWidth={customWidth}
                                                                globalCollapseAll={false}
                                                                index={index}
                                                                selectedAuthorName={''}
                                                            />
                                                            {/* <div className="resultsDivFooter"></div> */}
                                                        </div>
                                                    </>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    {localStorage.setItem(
                                        "displayedResults",
                                        JSON.stringify(displayedResults)
                                    )}
                                </div>
                            </>
                        );

                    } else {
                        localStorage.removeItem("displayedResults");
                        return (
                            <div className="results-no-search-content pubmed-results-no-search-content">
                                <span><b>No results were found.</b></span>
                            </div>
                        );
                    }
                })()}
            </>)

        } catch (error) {
            setError(error)
            // this.setState({ error: error, errorExpand: true });
        }


    };
    const resultListCount = (_itemsPerPage, _currentPage, _documentCount, _response) => {
        try {
            var endIndex, startIndex;
            startIndex = _currentPage * _itemsPerPage - _itemsPerPage;
            endIndex = _currentPage * _itemsPerPage;

            return (
                <div className={"results-count-wrapper pubmed-main-right-section-result-list-count box-white-main"}>
                    {_response.length > 0 && (
                        <div className="resultListCount-container">
                            {_documentCount > 0 && (
                                <span
                                    className="showingResultsCountContainer" /* style={{ display: "flex", width: "200px" }} */
                                >
                                    {endIndex <= _documentCount ? (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {endIndex.toLocaleString("en-us")} of{" "}
                                            {_documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    ) : (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {_documentCount.toLocaleString("en-us")} of{" "}
                                            {_documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    )}
                                </span>
                            )}
                            <span
                                style={{
                                    marginRight: "0.5%",
                                    display: "flex",
                                    width: "180px",
                                }}
                            >
                                <PageItems
                                    handleChangeSelectItems={handleChangeSelectItems}
                                    itemsPerPage={itemsPerPage}
                                    customWidth={customWidth}
                                />
                            </span>
                            {/* <div className="sort-by-wrapper">
                                    <span className="sort-by-text">Sort By:</span>
    
                                </div> */}
                        </div>
                    )}
                </div>
            );

        } catch (error) {
            setError(error);
            // this.setState({ error: error, errorExpand: true });
        }
    };
    const handleChangeSelectItems = async (items) => {
        try {
            let _ItemsPerPage = items, _currentPage = currentPage;
            await setItemsPerPage(items);
            let totalPages = Math.ceil(
                documentCount / items
            );
            if (totalPages < currentPage) {
                await setCurrentPage(totalPages);
                _currentPage = totalPages;
            }
            fetchCitation(citation, _ItemsPerPage, _currentPage);

        } catch (error) {
            setError(error);

            //this.setState({ error: error, errorExpand: true });
        }
    };
    const handlePageChange = (currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            setCurrentPage(currentPage);
            fetchCitation(citation, itemsPerPage, currentPage)

        } catch (error) {
            //this.setState({ error: error });
        }
    };

    return (<>
        <div className="pubmed-main-innerWrapper">
            <div className="pubmed-main-section-container">
                {(isLoaded) && <>
                    <div className={"pubmed-search-author-title results-count-wrapper pubmed-main-right-section-result-list-count box-white-main"}>
                        Cited by: {citation.length}
                    </div>
                    <div className="pubmed-main-section">
                        <div className="pubmed-author-main-section">
                            {error === ""
                                ? resultListCount(
                                    itemsPerPage,
                                    currentPage,
                                    documentCount,
                                    response
                                )
                                : ""}
                            <br />
                            {error === "" ? (
                                resultList(
                                    response,
                                    itemsPerPage,
                                    currentPage
                                )
                            ) : (
                                <>
                                    {(() => {
                                        let service = new Services();
                                        service.logService(
                                            error.stack,
                                            "error"
                                        );
                                    })()}

                                    <div style={{ margin: "2rem 2rem" }}>
                                        <h2>Sorry, something went wrong</h2>

                                        {errorExpand ? (
                                            <p
                                                style={{
                                                    backgroundColor: "#f8d4d4",
                                                    borderColor: "#f5a6a7",
                                                }}
                                            >
                                                {createErrorHtml()}
                                            </p>
                                        ) : (
                                            ""
                                        )}

                                        <p
                                            style={{
                                                fontSize: "0.9rem",
                                                marginTop: "30px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => { setErrorExpand(!errorExpand) }}
                                        >
                                            {errorExpand
                                                ? `SHOW LESS`
                                                : `SHOW DETAILS`}
                                        </p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <Pagination
                        metadata={documentCount}
                        handlePageChange={handlePageChange}
                        itemsPerPage={parseInt(itemsPerPage)}
                        page={parseInt(currentPage)}
                        customWidth={customWidth}
                        customHeight={customHeight}
                    />

                </>
                }
            </div>
        </div>
    </>)
}
export default PubMedCitationCard